import React from 'react';
import { BillingSectionProps } from './dashboard.types';
import styles from './Dashboard.module.css';

/**
 * Billing Section Component
 * 
 * Displays subscription and billing information with plan management options.
 * Shows current plan details and upgrade button.
 */
const BillingSection = ({ }: BillingSectionProps) => {
  // Mock data - replace with actual user subscription data
  const currentPlan = {
    name: "Free Plan",
    price: "0 SAR",
    interval: "/month",
    features: [
      "Access to basic features",
      "Limited credits",
      "Community support"
    ],
    isPremium: false
  };

  return (
    <section className={styles.plansSection}>
      <h3 className={styles.sectionTitle}>Subscription & Billing</h3>
      <p className={styles.sectionDescription}>Manage your current plan and billing details</p>

      <div className={styles.plansContent}>
        <div style={{ width: '100%' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
            <div>
              <h4 style={{ fontSize: '24px', fontWeight: '700', color: 'var(--Colors-Primary-800, #184342)', margin: '0' }}>
                {currentPlan.name}
              </h4>
              <p style={{ color: 'var(--Colors-Neutral-600, #937663)', margin: '4px 0 0 0' }}>
                Active subscription
              </p>
            </div>
            <div style={{ textAlign: 'right' }}>
              <span style={{ fontSize: '32px', fontWeight: '700', color: 'var(--Colors-Primary-600, #2d7f7d)' }}>
                {currentPlan.price}
              </span>
              <span style={{ color: 'var(--Colors-Neutral-500, #af9077)' }}>{currentPlan.interval}</span>
            </div>
          </div>

          <div style={{ marginBottom: '32px', borderTop: '1px solid var(--Colors-Neutral-200, #ecddcc)', borderBottom: '1px solid var(--Colors-Neutral-200, #ecddcc)', padding: '24px 0' }}>
            <h5 style={{ margin: '0 0 16px 0', fontSize: '16px', color: 'var(--Colors-Primary-800, #184342)' }}>Plan Features:</h5>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '12px' }}>
              {currentPlan.features.map((feature, index) => (
                <li key={index} style={{ display: 'flex', alignItems: 'center', gap: '8px', color: 'var(--Colors-Neutral-700, #715f57)' }}>
                  <span style={{ color: 'var(--Colors-Primary-600, #2d7f7d)', fontWeight: 'bold' }}>✓</span>
                  {feature}
                </li>
              ))}
            </ul>
          </div>

          <button className={styles.upgradeButton}>
            Upgrade to Premium
          </button>
        </div>
      </div>
    </section>
  );
};

export default BillingSection; 